import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { RefreshFacebookAccounts } from './__generated__/RefreshFacebookAccounts';
import { REFRESH_FACEBOOK_ACCOUNTS_MUTATION } from './refreshFacebookAccounts.mutation';

export const useRefreshFacebookAccounts = () => {
  return useMutation<RefreshFacebookAccounts>(REFRESH_FACEBOOK_ACCOUNTS_MUTATION, { client: kmsClient });
};
